<h1 class="mtx-dialog-title" *ngIf="data.title">
  <span>{{data.title | toObservable | async}}</span>
  <button mat-icon-button *ngIf="data.showCloseIcon" (click)="_onClose()">
    <mat-icon>close</mat-icon>
  </button>
</h1>
<div class="mtx-dialog-content" *ngIf="data.description">
  <p>{{data.description | toObservable | async}}</p>
</div>
<div class="mtx-dialog-actions">
  <ng-container *ngFor="let btn of data.buttons">
    <ng-container [ngSwitch]="btn.type">
      <ng-container *ngSwitchCase="'raised'">
        <button mat-raised-button *ngIf="btn.focusInitial" cdkFocusInitial
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
        <button mat-raised-button *ngIf="!btn.focusInitial"
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'stroked'">
        <button mat-stroked-button *ngIf="btn.focusInitial" cdkFocusInitial
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
        <button mat-stroked-button *ngIf="!btn.focusInitial"
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
      </ng-container>
      <ng-container *ngSwitchCase="'flat'">
        <button mat-flat-button *ngIf="btn.focusInitial" cdkFocusInitial
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
        <button mat-flat-button *ngIf="!btn.focusInitial"
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button mat-button *ngIf="btn.focusInitial" cdkFocusInitial
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
        <button mat-button *ngIf="!btn.focusInitial"
                [color]="btn.color" [ngClass]="btn.class!" (click)="_onClick(btn.onClick!)">
          {{btn.text | toObservable | async}}
        </button>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
